
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/erpcige/cigefi",
      function () {
        return require("private-next-pages/erpcige/cigefi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/erpcige/cigefi"])
      });
    }
  